import Icon from '../components/Icon.vue'

Icon.register({
  'phone-slash': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M268.2 381.4c11.5-5.4 22.7-11.6 33.6-18.1l80 61.8c-76 54.5-169 86.9-269.7 86.9-11.3 0-20.9-7.8-23.4-18.6l-24-104c-2.6-11.4 3.2-22.9 13.9-27.5l112-48c9.8-4.2 21.2-1.4 28 6.9zM633.8 458.1c7 5.4 8.3 15.5 2.9 22.3l-19.6 25.3c-5.5 7-15.5 8.2-22.5 2.8l-588.4-454.7c-7-5.4-8.2-15.4-2.8-22.4l19.6-25.2c5.5-7 15.5-8.2 22.5-2.8l353.9 273.5c18.1-22.5 33.8-46.7 46-72.8l-60.6-49.6c-8.3-6.7-11.1-18.2-6.9-28l48-112c4.6-10.6 16.2-16.5 27.5-13.9l104 24c10.9 2.5 18.6 12.2 18.6 23.4 0 108.9-38.1 208.4-100.9 287.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/phone-slash.js
// module id = 1631
// module chunks = 0